<template>
  <!--
          作者 tanzhihui
          时间：2020-10-12
          描述：插件-一物一码-编码列表
      -->
  <div class="user">
    <!--搜索编码-->
    <div class="d-b-c">
      <div class="mb18"><el-button size="small" icon="el-icon-plus" type="primary" @click="back">返回</el-button></div>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="searchForm.search" placeholder="请输入编码"></el-input></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="code" label="编码" width="200"></el-table-column>
          <el-table-column prop="use_time" label="是否占用" width="200" :formatter="use_time"></el-table-column>
          <el-table-column prop="is_use" label="是否使用" width="200" :formatter="is_use"></el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="300"></el-table-column>
          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button @click="openCode(scope.row.code_id)" type="text" size="small">查看二维码</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import CodeBatchApi from '@/api/codebatch.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*批次ID */
        code_batch_id:0,
        /*搜索表单对象*/
        searchForm: {}
      };
    },
    created() {
      this.code_batch_id = this.$route.query.code_batch_id;
      /*获取列表*/
      this.getData(this.code_batch_id);
    },

    methods: {
      /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*是否占用 */
    use_time(row, column){
      if (row.use_time === 0) {
          return '可使用'
        } else  {
          return '被占用'
        }
    },
    /*是否使用 */
     is_use(row, column){
      if (row.is_use === 0) {
          return '未使用'
        } else  {
          return '已使用'
        }
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.code_batch_id = this.code_batch_id;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        CodeBatchApi.codelist(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },

      //查看推广二维码
    openCode(code_id){
        let self = this;
        let form = {
          'code_id':code_id,
          'batch_id':self.code_batch_id
        };

        self.loading = true;
        CodeBatchApi.findPosterCode(form, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {

            this.$alert('<img src="'+data.data.qrcode+'" style="width:300px;height:300px">', '查看二维码', {
              dangerouslyUseHTMLString: true
            });
          } else {
            self.$message({
              message: '二维码生成失败',
              type: 'error'
            });
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },


      /*返回上一页*/
      back() {
        this.$router.back(-1);
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/codebatch/code/index.vue